var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.cellDuties,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        on: {
          "on-row-dblclick": function($event) {
            return _vm.gotoDuty($event.row)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.gotoDuty(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-right" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-success mt-2", on: { click: _vm.gotoNewDuty } },
        [_c("i", { staticClass: "fa fa-plus" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }